import { render, staticRenderFns } from "./NonMainLayout.layout.vue?vue&type=template&id=3b9a2985&scoped=true&"
import script from "./NonMainLayout.layout.vue?vue&type=script&lang=ts&"
export * from "./NonMainLayout.layout.vue?vue&type=script&lang=ts&"
import style0 from "./NonMainLayout.layout.vue?vue&type=style&index=0&id=3b9a2985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9a2985",
  null
  
)

export default component.exports